export default __webpack_public_path__ + "static/color-role-dont-light-8d1b98fa5dabc2a48581251ed4a0e5977122a8b708398660c4726b4f894875f4.png";